import axios from "axios";
import { API } from "../../App";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const absUrl = (path) => (path ? `${BACKEND}${path}` : null);

export const adminHeaders = () => {
  const t = localStorage.getItem("admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const getSessionId = () => {
  let sid = sessionStorage.getItem("bsz_preview_sid");
  if (!sid) {
    sid = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`).replace(/[^a-z0-9-]/gi, "");
    sessionStorage.setItem("bsz_preview_sid", sid);
  }
  return sid;
};

export const trackPreview = (event, extra = {}) => {
  axios
    .post(`${API}/preview-page/event`, { event, session_id: getSessionId(), ...extra }, { headers: adminHeaders() })
    .catch(() => {});
};

export const visitContext = () => {
  const q = new URLSearchParams(window.location.search);
  return {
    referrer: document.referrer || null,
    utm_source: q.get("utm_source"),
    utm_medium: q.get("utm_medium"),
    utm_campaign: q.get("utm_campaign"),
  };
};
